module.exports = __webpack_public_path__ + "img/芒果1.09cf8211.png";